import { render, staticRenderFns } from "./past-context-menu.vue?vue&type=template&id=7012f830"
import script from "./past-context-menu.vue?vue&type=script&lang=js"
export * from "./past-context-menu.vue?vue&type=script&lang=js"
import style0 from "./past-context-menu.vue?vue&type=style&index=0&id=7012f830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports